<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
import { toastsModel,toCurrency } from '@/service/commuse'

export default {
  name: 'LineChart',
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData','options','styles'],

  computed:{

  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData() {
      this.renderChart(this.chartData, this.options);
    },
  },
}
</script>
